<div class="modal-header" appCustomAutofocus>
    <h3>Direct Deposit</h3>
</div>
<div class="modal-body">
    <div *ngFor="let data of accountList;let $index = index">
        <div class="card border">
            <div class="card-header bg-light">{{accountName[$index]}} Account</div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-2">
                        <label><strong>Routing #</strong></label>
                        <p>{{data.RoutingID}}</p>
                    </div>
                    <div class="col-lg-2">
                        <label><strong>Account #</strong></label>
                        <p>{{data.BankAcct}}</p>
                    </div>
                    <div class="col-lg-2">
                        <label><strong>Account Type</strong></label>
                        <div [ngClass]="{invalidField: data.AcctType == null}">
                            <div>
                                <input type="radio" [(ngModel)]="data.AcctType" value="C" [required]="data.AcctType == null" [disabled]="true" />
                                Checking
                            </div>
                            <br />
                            <div>
                                <input type="radio" [(ngModel)]="data.AcctType" value="S" [required]="data.AcctType == null" [disabled]="true" />
                                Savings
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div *ngIf="$index != 0">
                            <label><strong>Savings Method</strong></label>
                            <div [ngClass]="{invalidField: data.Method == null}">
                                <div>
                                    <input type="radio" [(ngModel)]="data.Method" value="P" [required]="data.Method == null" [disabled]="true" />
                                    Percent
                                </div>
                                <br />
                                <div>
                                    <input type="radio" [(ngModel)]="data.Method" value="A" [required]="data.Method == null" [disabled]="true" />
                                    $ Amount
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2" *ngIf="data.Method != null && $index != 0">
                        <label *ngIf="data.Method === 'A'"><strong>Amount</strong></label>
                        <label *ngIf="data.Method === 'P'"><strong>Percent</strong></label>
                        <div>
                            <p *ngIf="data.Method === 'A'">{{data.Amount}}</p>
                            <p *ngIf="data.Method === 'P'">{{data.Pct}}</p>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 10px;">
                    <div class="col-lg-5" *ngIf="data.Attachments != null">
                        <a href="/Document/GetDBAttachment?attachmentID={{data.Attachments.FileAttachmentID}}"> {{data.Attachments.AttachmentFileName}}</a>
                    </div>
                </div>
            </div>
        </div>
        <br />
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-outline-dark" type="button" (click)="closeClick()">Close</button>
</div>
